var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"re-spinner text-center"},[_c('b-spinner',{attrs:{"type":"border","variant":_vm.variant}}),_vm._v(" "+_vm._s(_vm.message)+" ")],1)
}
var staticRenderFns = []

export { render, staticRenderFns }